import React from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';
import configData from '../config.json';

const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: configData.APPINSIGHTS_CONNECTION_STRING,
    enableAutoRouteTracking: true,
    appId: 'Airswift.UI',
    loggingLevelConsole: 1,
    loggingLevelTelemetry: 2,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableAjaxErrorStatusText: true,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    },
    correlationHeaderExcludedDomains: [configData.REACT_APP_B2C_TENANT_ID]
  }
});

appInsights.loadAppInsights();

appInsights.trackPageView();

appInsights.addTelemetryInitializer((envelope) => {
  envelope.tags['ai.cloud.role'] = 'AirSwift.UI';
  envelope.tags['ai.cloud.roleInstance'] = 'AirSwift.UI';
});

export default (Component) => withAITracking(reactPlugin, Component);
export { reactPlugin, appInsights };
